import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Start from "./pages/Start";
import Confirm from "./pages/Confirm";
import Login from "./pages/Login";
import BookDemo from "./pages/BookDemo";
import AdminDashboard from "./pages/SuperadminDashboard/SuperadminDashboard";
import ClinicDashboard from "./pages/ClinicDashboard";
import StaffDashboard from "./pages/StaffDashboard";
import InviteStaff from "./pages/InviteStaff";
import './styles/SuperadminDashboard.css';
import CreateClinic from "./components/Dashboard/CreateClinic";
import CustomizeChatbot from "./components/Dashboard/CustomizeChatbot";
import AiTraining from "./components/Dashboard/AiTraing";
import ClinicSetupLayout from "./layouts/ClinicSetupLayout";
import IntakePage from "./pages/IntakePage";
import { ClinicProvider } from "./context/ClinicContext";
import PublishPage from "./components/Dashboard/PublishPage";
import TestChatbot from "./pages/TestChatbot";
import MockTrainingPage from "./components/Dashboard/MockTrainingPage";
import ClinicChatPage from "./pages/ClinicChatPage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/confirm" element={<Confirm />} />
        <Route path="/start" element={<Start />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/dashboard" element={<ClinicDashboard />} />
        <Route path="/staff" element={<StaffDashboard />} />
        <Route path="/invite-staff" element={<InviteStaff />} />
        
        <Route path="/intake" element={<IntakePage />} />
        <Route path="/chat" element={<TestChatbot />} />
        <Route path="/admin/mocktraining" element={<MockTrainingPage />} />
        <Route path="/chat/:clinicKey" element={<ClinicChatPage />} />


        {/* Only wrap the setup flow pages AFTER clinic is created */}
        <Route
          path="/admin/create-clinic"
          element={
            <ClinicProvider>
              <CreateClinic />
            </ClinicProvider>
        }
        />



        <Route
          path="/admin/Customize-Chatbot"
          element={
            <ClinicProvider>
              <ClinicSetupLayout>
                <CustomizeChatbot />
              </ClinicSetupLayout>
            </ClinicProvider>
          }
        />

        <Route
          path="/admin/AiTraining"
          element={
            <ClinicProvider>
              <ClinicSetupLayout>
                <AiTraining />
              </ClinicSetupLayout>
            </ClinicProvider>
          }
        />

        
        <Route
          path="/admin/publish"
          element={
            <ClinicProvider>
              <ClinicSetupLayout>
                <PublishPage />
              </ClinicSetupLayout>
            </ClinicProvider>
          }
        />
      </Routes>

      
    </Router>
  );
}

export default App;
